import axios from "axios";

export default {
  getPaymentParams: (plan_name) => {
    let url = `/djangoflutterwave/payment-params/?plan=${plan_name}`;
    return axios.get(url);
  },
};
